export default () => {
  const { inSidedData, mixpanel, sessionStorage } = window
  const { communityId, user: { userid } } = inSidedData
  const distinct_id = `${communityId}:${userid}`

  const UserLoggedIn = sessionStorage.getItem('UserLoggedIn') || null
  const UserRegistered = sessionStorage.getItem('UserRegistered') || null
  const UserLoggedOut = sessionStorage.getItem('UserLoggedOut') || null

  if (UserLoggedIn) {
    mixpanel.identify(distinct_id)
    sessionStorage.removeItem('UserLoggedIn')
    return
  }

  if (UserRegistered) {
    mixpanel.alias(distinct_id)
    sessionStorage.removeItem('UserRegistered')
    return
  }

  if (UserLoggedOut) {
    mixpanel.reset()
    sessionStorage.removeItem('UserLoggedOut')
    return
  }
}
